(function () {

    "use strict";

    angular
        .module('harriApp')
        .controller("LoadFromTemplateModal", LoadFromTemplateModal);

    LoadFromTemplateModal.$inject = ['$scope', 'modalData', 'onSave'];

    function LoadFromTemplateModal ($scope, modalData, onSave) {
        var self = this;

        self.templates = modalData['templates'];
        self.templateIsRequired = false;

        self.loadTemplate = function () {
            if (self.template) {
                onSave(self.template.id, self.includeSales);
                delete self.templateIsRequired;
                self.close();
            } else {
                self.templateIsRequired = true;
            }
        };

        self.close = function () {
            $scope.$hide();
        };
    }

})();